module.exports = __webpack_public_path__ + "img/menu.0165ce06.png";